"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecimalExpNeg = exports.State = void 0;
var State;
(function (State) {
    State[State["UNKNOWN"] = 0] = "UNKNOWN";
    State[State["ING"] = 1] = "ING";
    State[State["DONE"] = 2] = "DONE";
    State[State["FAILED"] = 3] = "FAILED";
})(State || (exports.State = State = {}));
// 设置科学计数法的精度配置
exports.DecimalExpNeg = -20;
